"use strict";
'use es6';

var _interopRequireWildcard = require("@babel/runtime/helpers/interopRequireWildcard");

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;

var _extends2 = _interopRequireDefault(require("@babel/runtime/helpers/extends"));

var _objectWithoutProperties2 = _interopRequireDefault(require("@babel/runtime/helpers/objectWithoutProperties"));

var _classCallCheck2 = _interopRequireDefault(require("@babel/runtime/helpers/classCallCheck"));

var _createClass2 = _interopRequireDefault(require("@babel/runtime/helpers/createClass"));

var _possibleConstructorReturn2 = _interopRequireDefault(require("@babel/runtime/helpers/possibleConstructorReturn"));

var _getPrototypeOf2 = _interopRequireDefault(require("@babel/runtime/helpers/getPrototypeOf"));

var _inherits2 = _interopRequireDefault(require("@babel/runtime/helpers/inherits"));

var _taggedTemplateLiteralLoose2 = _interopRequireDefault(require("@babel/runtime/helpers/taggedTemplateLiteralLoose"));

var _react = _interopRequireWildcard(require("react"));

var _classNames = _interopRequireDefault(require("react-utils/classNames"));

var _styledComponents = _interopRequireDefault(require("styled-components"));

var _misc = require("HubStyleTokens/misc");

var _sizes = require("HubStyleTokens/sizes");

var _theme = require("HubStyleTokens/theme");

var _times = require("HubStyleTokens/times");

var _UIScrollContainer = _interopRequireDefault(require("../scroll/UIScrollContainer"));

var _UISection = _interopRequireDefault(require("../section/UISection"));

var _component = _interopRequireDefault(require("../utils/propTypes/component"));

var _Styles = require("../utils/Styles");

var _Color = require("../core/Color");

function _templateObject2() {
  var data = (0, _taggedTemplateLiteralLoose2.default)(["\n  font-size: ", ";\n  background-color: ", ";\n  border-collapse: collapse;\n  width: 100%;\n  ", ";\n\n  th,\n  td {\n    border-color: ", ";\n    border-style: solid;\n    border-width: 1px 0 0;\n    line-height: normal;\n    vertical-align: middle;\n  }\n\n  thead {\n    th {\n      ", ";\n      font-size: ", ";\n      background-color: ", ";\n      color: ", ";\n      height: ", ";\n      padding-bottom: ", ";\n      padding-left: ", ";\n      padding-right: ", ";\n      padding-top: ", ";\n      text-align: left;\n      text-transform: uppercase;\n      vertical-align: ", ";\n    }\n  }\n\n  tfoot {\n    td,\n    th {\n      ", ";\n      height: ", ";\n      padding: ", " ", ";\n      text-align: left;\n    }\n  }\n\n  tbody {\n    td {\n      hyphens: auto;\n      height: ", ";\n      overflow-wrap: break-word; /* prevent overflow in Chrome 55+ (issue #1494) */\n      padding: ", " ", ";\n      vertical-align: ", ";\n\n      .private-tag--inline {\n        vertical-align: ", "; /* issue #1267 */\n      }\n    }\n  }\n\n  ", ";\n\n  ", ";\n\n  ", ";\n\n  ", ";\n\n  /* Scroll wrapper: Will scroll table sideways within container (#952) */\n  .private-scroll__wrapper--horizontal & {\n    background-color: transparent;\n\n    @media only screen and (max-width: ", ") {\n      table-layout: auto;\n    }\n  }\n\n  /* HACK: contextual styling for Tables-in-Cards */\n  .private-card & {\n    border: 0;\n    border-radius: inherit;\n\n    thead {\n      th,\n      .private-table-sort-toggle {\n        background-color: transparent;\n        border-top: 0;\n      }\n    }\n  }\n\n  /* HACK: contextual styling for Tables-in-Panels */\n  .private-panel__body & {\n    ", ";\n  }\n"]);

  _templateObject2 = function _templateObject2() {
    return data;
  };

  return data;
}

function _templateObject() {
  var data = (0, _taggedTemplateLiteralLoose2.default)(["\n  height: ", ";\n"]);

  _templateObject = function _templateObject() {
    return data;
  };

  return data;
}

var TH_BACKGROUND_COLOR = (0, _Color.hexToTransparentRGBA)(_theme.TABLE_HEADER_BACKGROUND_COLOR);
var TableScrollContainer = (0, _styledComponents.default)(_UIScrollContainer.default).withConfig({
  displayName: "UITable__TableScrollContainer",
  componentId: "sc-16dl79r-0"
})(_templateObject(), function (_ref) {
  var scrollDirection = _ref.scrollDirection;
  return scrollDirection === 'both' && '100%';
});

var Table = _styledComponents.default.table.attrs({
  className: function className(_ref2) {
    var _className = _ref2.className,
        bordered = _ref2.bordered,
        condensed = _ref2.condensed,
        hover = _ref2.hover,
        responsive = _ref2.responsive;
    return (0, _classNames.default)('table private-table', _className, {
      'table-bordered private-table--bordered': bordered,
      'table-condensed private-table--condensed': condensed,
      'table-hover private-table--hover': hover,
      'private-table--responsive': responsive
    });
  }
}).withConfig({
  displayName: "UITable__Table",
  componentId: "sc-16dl79r-1"
})(_templateObject2(), _sizes.TABLE_DEFAULT_FONT_SIZE, _theme.TABLE_BACKGROUND_COLOR, function (props) {
  return (props.flush || props.responsive) && "&& { margin-bottom: 0; }";
}, _theme.TABLE_BORDER_COLOR, _Styles.FONT_FAMILIES.medium, _sizes.TABLE_HEADER_FONT_SIZE, TH_BACKGROUND_COLOR, _theme.BASE_FONT_COLOR, _sizes.TABLE_HEADER_HEIGHT, _sizes.TABLE_HEADER_PADDING_BOTTOM, _sizes.TABLE_DEFAULT_PADDING_X, _sizes.TABLE_DEFAULT_PADDING_X, _sizes.TABLE_HEADER_PADDING_TOP, _misc.TABLE_HEADER_VERTICAL_ALIGNMENT, _Styles.FONT_FAMILIES.demibold, _sizes.TABLE_CELL_HEIGHT, _sizes.TABLE_DEFAULT_PADDING_Y, _sizes.TABLE_DEFAULT_PADDING_X, _sizes.TABLE_CELL_HEIGHT, _sizes.TABLE_DEFAULT_PADDING_Y, _sizes.TABLE_DEFAULT_PADDING_X, _misc.TABLE_CELL_VERTICAL_ALIGNMENT, _misc.TABLE_CELL_VERTICAL_ALIGNMENT, function (props) {
  return props.bordered && "\n      border-color: " + _theme.TABLE_BORDER_COLOR + ";\n      border-style: solid;\n      border-width: 0 1px 1px;\n  ";
}, function (props) {
  return props.condensed && "\n      thead th {\n        height: " + _sizes.TABLE_HEADER_HEIGHT + ";\n        padding-bottom: " + _sizes.TABLE_COMPACT_PADDING_Y + ";\n        padding-top: " + _sizes.TABLE_COMPACT_PADDING_Y + "\n      }\n\n      tbody {\n        td, th {\n          height: " + _sizes.TABLE_COMPACT_CELL_HEIGHT + ";\n          padding-bottom: " + _sizes.TABLE_COMPACT_PADDING_Y + ";\n          padding-top: " + _sizes.TABLE_COMPACT_PADDING_Y + ";\n        }\n      }\n  ";
}, function (props) {
  return props.hover && "\n      tbody {\n        tr {\n          transition: background-color " + _times.MICRO_TRANSITION_TIMING + " ease-out;\n        }\n        tr:hover,\n        tr .private-table--hovered {\n          background-color: " + _theme.TABLE_ROW_HOVER_BACKGROUND_COLOR + ";\n        }\n      }\n  ";
}, function (props) {
  return props.truncated && "\n      table-layout: fixed;\n\n      td,\n      th {\n        overflow: hidden;\n        text-overflow: ellipsis;\n        white-space: nowrap;\n      }\n  ";
}, _sizes.GRID_BREAKPOINT_MEDIUM, function (props) {
  return props.bordered && "border-width: 0 0 1px;";
});

var UITable =
/*#__PURE__*/
function (_React$Component) {
  (0, _inherits2.default)(UITable, _React$Component);

  function UITable() {
    (0, _classCallCheck2.default)(this, UITable);
    return (0, _possibleConstructorReturn2.default)(this, (0, _getPrototypeOf2.default)(UITable).apply(this, arguments));
  }

  (0, _createClass2.default)(UITable, [{
    key: "render",
    value: function render() {
      var _this$props = this.props,
          bordered = _this$props.bordered,
          children = _this$props.children,
          className = _this$props.className,
          condensed = _this$props.condensed,
          flush = _this$props.flush,
          height = _this$props.height,
          hover = _this$props.hover,
          responsive = _this$props.responsive,
          responsiveWrapperClassName = _this$props.responsiveWrapperClassName,
          ScrollContainer = _this$props.ScrollContainer,
          truncated = _this$props.truncated,
          rest = (0, _objectWithoutProperties2.default)(_this$props, ["bordered", "children", "className", "condensed", "flush", "height", "hover", "responsive", "responsiveWrapperClassName", "ScrollContainer", "truncated"]);

      var renderedTable = _react.default.createElement(Table, (0, _extends2.default)({}, rest, {
        className: className,
        bordered: bordered,
        condensed: condensed,
        flush: flush,
        hover: hover,
        responsive: responsive,
        truncated: truncated
      }), children);

      return responsive ? _react.default.createElement(_UISection.default, {
        className: (0, _classNames.default)(responsiveWrapperClassName, 'table-responsive', 'private-scroll__wrapper--tables'),
        flush: flush,
        height: height
      }, _react.default.createElement(ScrollContainer, {
        scrollDirection: height != null ? 'both' : 'horizontal'
      }, renderedTable)) : renderedTable;
    }
  }]);
  return UITable;
}(_react.default.Component);

exports.default = UITable;
UITable.propTypes = {
  bordered: _react.PropTypes.bool.isRequired,
  children: _react.PropTypes.node.isRequired,
  condensed: _react.PropTypes.bool.isRequired,
  flush: _react.PropTypes.bool.isRequired,
  height: _UISection.default.propTypes.height,
  hover: _react.PropTypes.bool.isRequired,
  responsive: _react.PropTypes.bool.isRequired,
  responsiveWrapperClassName: _react.PropTypes.string,
  ScrollContainer: _component.default.isRequired,
  truncated: _react.PropTypes.bool.isRequired
};
UITable.defaultProps = {
  bordered: true,
  condensed: false,
  flush: false,
  hover: true,
  responsive: true,
  ScrollContainer: TableScrollContainer,
  truncated: false
};
UITable.displayName = 'UITable';
module.exports = exports.default;